require('./_loginForm.scss');

// @ vendor
import React from 'react';
import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

// @ components
import OKLogin from 'ok-login';
import { initOptions } from 'ok-login';

// @ core
import { cookiesDomain } from 'core/environmentConfig';
const { getLanguage } = require('core/i18n').i18n;
import apiURLBuilder from 'core/apiURLBuilder';

// @ utilities
const loginHelper = require('utilities/loginHelper');

// @ constants
import { LOCAL_ENVIRONMENT } from 'constants/index';


class LoginForm extends Component {
    constructor(props) {
        super(props);
        this.handleRegisterLoginError = __CONTACT_CENTER__ ? this.handleRegisterLoginErrorContactCenter.bind(this) : () => {};
    }

    componentDidMount() {
        if (__CONTACT_CENTER__) {
            const {
                history,
                location: { state: { nextPathname } = {} }
            } = this.props;

            const options = {
                nextPathname,
                containerSelector: '#customLoginContainer',
                registerLoginErrorCallback: this.handleRegisterLoginError
            }

            loginHelper.executeSharedLogin(options, history);
        }
    }

    handleRegisterLoginErrorContactCenter = (response) => {
        const { registerError } = this.props;
        registerError(response);
    }
    render() {
        const { originCountry } = this.props;
        if (!__CONTACT_CENTER__) {
            const config = {
                psd2: true,
                lang: getLanguage(),
                country: originCountry || 'ES',
                authentication: {
                    url: apiURLBuilder.getModelAuthURL('requestUserTokenMB'),
                    onbUrl: apiURLBuilder.getURL('requestUserToken'),
                    headers: {},
                    payload: {
                        force: true
                    }
                },
                offlog: {
                    url: apiURLBuilder.getURL('generateOfflogToken'),
                    headers: {}
                },
                profile: {
                    url: apiURLBuilder.getURL('userProfile'),
                    headers: {}
                },
                otp: {
                    url: apiURLBuilder.getModelAuthURL('otpVerifyMB'),
                    renewOTPUrl: apiURLBuilder.getModelAuthURL('regenerateTokenMB'),
                    headers : {}
                },
                onLoginSuccess: function(){
                    location.href = location.origin + '/myprofile/global';  // This is intentional to simulate login from public site
                },
                onLoginError: function(){},
                ...(window.__ENV__ !== LOCAL_ENVIRONMENT ? {
                    cookiesDomain: `.${cookiesDomain}`
                } : {})
            };

            const options = initOptions(config);
            return (
                <div className="login login--in" id="customLoginContainer">
                    <OKLogin options={options} />,
                </div>
            );
        }

        return (<div className="login login--in" id="customLoginContainer"></div>);
    }
}

LoginForm.propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object,
    registerError: PropTypes.func,
    originCountry: PropTypes.string
};

module.exports.LoginForm = withRouter(LoginForm);
